var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "profile-2user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.138,
    height: 54.138,
    viewBox: "0 0 54.138 54.138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.376,20.009a4.1,4.1,0,0,0-.744,0,10.027,10.027,0,1,1,.744,0Z",
    transform: "translate(10.286 4.512)",
    fill: "none",
    stroke: "#0098da",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M.293,0a7.889,7.889,0,0,1,7.9,7.9,7.906,7.906,0,0,1-7.6,7.9,2.548,2.548,0,0,0-.586,0",
    transform: "translate(36.724 9.023)",
    fill: "none",
    stroke: "#0098da",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M4.094,3.1c-5.459,3.654-5.459,9.61,0,13.241,6.2,4.151,16.377,4.151,22.58,0,5.459-3.654,5.459-9.61,0-13.241C20.494-1.032,10.32-1.032,4.094,3.1Z",
    transform: "translate(5.29 29.748)",
    fill: "none",
    stroke: "#0098da",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,13.535a10.912,10.912,0,0,0,4.421-1.963c3.519-2.639,3.519-6.993,0-9.632A11.219,11.219,0,0,0,.068,0",
    transform: "translate(41.37 31.581)",
    fill: "none",
    stroke: "#0098da",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H54.138V54.138H0Z",
    transform: "translate(54.138 54.138) rotate(180)",
    fill: "none",
    opacity: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudents);
export default __webpack_public_path__ + "static/media/students.5ced505f1e6be2c6f41d79d34271855b.svg";
export { ForwardRef as ReactComponent };